import { motion } from "framer-motion";

export const BannerStrip = ({ testId = "page-banner" }) => (
  <div className="max-w-7xl mx-auto px-6 md:px-12 -mt-4 mb-4">
    <motion.img
      src="/banner.webp"
      alt="Heritage Family Protection Agency — Life, Health, Mortgage, Retirement, Legal, Taxes"
      data-testid={testId}
      initial={{ opacity: 0, y: 14 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.9 }}
      className="w-full h-auto rounded-2xl border border-[#bf953f]/25 shadow-[0_0_60px_rgba(191,149,63,0.15)]"
    />
  </div>
);
